
import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "organization";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    getList: ({platformId, kind}) => [`${prefix}/${namespace}/${kind}`],
    getFromOrganization: (organizationId) => [`${prefix}/profile/${namespace}/${organizationId}/legalcontact`]
  },
  post: {
    create: (organizationId, data) => [`${prefix}/profile/${namespace}/${organizationId}/legalcontact`, data]
  },
  put: {
    update: (data) => [`${prefix}/profile/${namespace}/${data.organization_id}/legalcontact/${data.id}`, data]
  },
})

export default nameSpace;
